import { lazy, type ReactNode, Suspense } from 'react'
import { ScreenState } from '../app/ScreenState.js'

/**
 * WP-C's route entries. Each screen is a lazy chunk so Pixi stays out of the app shell
 * (ARCHITECTURE §9, PERF-05): only `/yuva` pulls it, and only when the child gets there.
 */

const Yuva = lazy(() => import('./YuvaScreen.js').then((m) => ({ default: m.YuvaScreen })))
const Shop = lazy(() => import('./ShopScreen.js').then((m) => ({ default: m.ShopScreen })))
const Wardrobe = lazy(() =>
  import('./WardrobeScreen.js').then((m) => ({ default: m.WardrobeScreen })),
)
const Badges = lazy(() => import('./BadgesScreen.js').then((m) => ({ default: m.BadgesScreen })))

function Loading({ children }: { children: ReactNode }) {
  return (
    <Suspense
      fallback={
        <ScreenState status="loading" onRetry={() => window.location.reload()}>
          {null}
        </ScreenState>
      }
    >
      {children}
    </Suspense>
  )
}

export const YuvaRoute = () => (
  <Loading>
    <Yuva />
  </Loading>
)
export const ShopRoute = () => (
  <Loading>
    <Shop />
  </Loading>
)
export const WardrobeRoute = () => (
  <Loading>
    <Wardrobe />
  </Loading>
)
export const BadgesRoute = () => (
  <Loading>
    <Badges />
  </Loading>
)
